import * as React from 'react';
import { UtilityText, StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import type { TerminalNodeType } from '../../types';
import { nodeHeight, nodeWidth } from '../../constants';

const typeLabels: Record<TerminalNodeType, string> = {
  start: 'START',
  end: 'END',
};

export const TerminalNode = ({ type }: { type: TerminalNodeType }) => {
  const { formatMessage } = useIntl();
  const typeLabel = formatMessage({ id: typeLabels[type] });

  return (
    <StackLayout
      css={{
        background: '$surfaceBackgroundTertiary',
        spacing: '$one',
        borderRadius: '$pill',
        width: nodeWidth[type],
        height: nodeHeight[type],
      }}
      horizontalAlignment="center"
      verticalAlignment="center"
    >
      <UtilityText size="eyebrow" emphasis="emphasized">
        {typeLabel}
      </UtilityText>
    </StackLayout>
  );
};
